// extracted by mini-css-extract-plugin
export default {"month":"style_month__V6rWv","year":"style_year__BnPq3"};